import { ChatSettings } from '@offconon/core-api';

export interface ChatChannelListState {
  chatSettings?: ChatSettings;
  loading: boolean;
  error: string | null;
}

export const initialState: ChatChannelListState = {
  loading: false,
  error: null,
};
